import { HttpClient } from '../../httpClient'

/** Soft-hides a single version (clears is_visible server-side). */
export const hideContentVersion = async ({
  id,
}: {
  id: string
}): Promise<void> => {
  const url = new URL(`/v3/content_versions/${id}`, window.location.origin)

  await HttpClient().delete(url.toString())
}
